<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="180px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderNumber" label="订单编号">
              {{ formData.orderNumber || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderType" label="订单类型">
              {{ formData.orderType == '1' ? '一口价' : '暂定价' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="userName" label="采购方">
              {{ formData.userName || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="supplierName" label="供应商名称">
              {{ formData.supplierName || "--" }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="specName" label="商品名称">
              {{ formData.specName || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="orderType === '1'">
            <el-form-item prop="lockedPrice" label="锁定单价(元)">
              {{ formData.lockedPrice || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="orderType === '2'">
            <el-form-item prop="lockedPrice" label="暂定单价(元)">
              {{ (formData.lockedPrice - formData.priceDiff) || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="" v-if="orderType == '2' && formData.parentOrderId" label="确认价">
              {{ formData.lockedPrice || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.resPrice">
            <el-form-item prop="resPrice" :label="`${formData.hgState !== '1' ? '补贴金额' : '转让价格'}(元)`">
              {{ formData.resPrice || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderQuantity" label="锁定数量">
              {{ formData.orderQuantity || "0" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="usedQuantity" label="已用数量">
              {{ formData.usedQuantity || "0" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="kyQuantity" label="可用数量">
              {{ formData.kyQuantity || "0" }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="priceDiff" label="价格差(元)">
              {{ formData.priceDiff || "" }}
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item prop="orderDepositType" label="保证金类型">
              {{ orderDepositTypeMap.get(formData.orderDepositType) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderDeposit" label="保证金比例">
              {{ formData.orderDeposit || "0" }}{{formData.orderDepositType && formData.orderDepositType === '2' ? (formData.specUnit ? '/' + formData.specUnit : '') : '%'}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="contractNo" label="合同编号">
              {{ formData.contractNo || "--" }}
            </el-form-item>
          </el-col>
          <!-- 外部点价编号仅适用于暂定价订单，一口价详情不展示。 -->
          <el-col v-if="formData.orderType === '2'" :span="12">
            <el-form-item prop="priceOrderNo" label="外部点价编号">
              {{ formData.priceOrderNo || "--" }}
            </el-form-item>
          </el-col>
          <!-- 点价约定仅适用于暂定价订单，一口价详情不展示。 -->
          <el-col v-if="formData.orderType === '2'" :span="12">
            <el-form-item label="最晚点价日期">{{ formData.latestPriceDate || "--" }}</el-form-item>
          </el-col>
          <el-col v-if="formData.orderType === '2'" :span="12">
            <el-form-item label="期货合约">{{ formData.futuresContract || "--" }}</el-form-item>
          </el-col>
          <el-col v-if="formData.orderType === '2'" :span="12">
            <el-form-item label="基差">{{ formData.basisPrice == null ? "" : formData.basisPrice }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="lossBearer" label="损耗承担方">
              {{ formData.lossBearer === '2' ? '供应商' : '采购方' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="demandTitle" label="关联采购询价">
              {{ formData.demandTitle || "未关联" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="quotePrice" label="关联采购报价">
              <span v-if="formData.quoteId">{{ formData.quoteSupplierName || "--" }} / {{ formData.quotePrice }}元</span>
              <span v-else>未关联</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="lockedDepositDeposit" label="锁定保证金(元)">
              {{ formData.lockedDepositDeposit || "" }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="lockedDeposit" label="锁定保证金(充值)(元)">
              {{ formData.lockedDepositDeposit || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="lockedDeposit" label="锁定保证金(其他)(元)">
              {{ formData.lockedPickupDeposit || "" }}
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item prop="orderStatus" label="订单状态">
              <template v-if="formData.resState !== '1'">
                <el-tag type="warning">货转中</el-tag>
              </template>
              <template v-else>
                <el-tag type="warning" v-if="formData.orderStatus == '1'">待审批</el-tag>
                <el-tag type="primary" v-if="formData.orderStatus == '2'">进行中</el-tag>
                <el-tag type="success" v-if="formData.orderStatus == '3'">已完成</el-tag>
                <el-tag type="danger" v-if="formData.orderStatus == '4'">驳回作废</el-tag>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ctime" label="提货日期">
              {{ formData.pickupDate || "--" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="usedAddQuantity" label="提货进行中数量">
              {{ formData.usedAddQuantity || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formData.fileList && formData.fileList.length > 0">
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="审批记录">
              <el-timeline :reverse="true" placement="top">
                <el-timeline-item placement="top" v-for="(item, index) of formData.recordList" :key="index"
                  :timestamp="item.approvalTime || '--'">
                  <el-card>
                    <el-row>
                      <el-col :span="24" v-if="item.approvalStatus && item.approvalName != '修改点价订单'">
                        审批状态：
                        <el-tag v-if="item.approvalStatus == '1'">待审批</el-tag>
                        <el-tag type="success" v-if="item.approvalStatus == '2'">审批通过</el-tag>
                        <el-tag type="danger" v-if="item.approvalStatus == '3'">审批驳回</el-tag>
                      </el-col>
                      <el-col :span="24">
                        审批名称：{{ item.approvalName || "--" }}
                      </el-col>
                    </el-row>
                    <el-row v-if="item.approvalName != '修改点价订单'">
                      <el-col :span="24">
                        审批意见：{{ item.approvalComments || "--" }}
                      </el-col>
                    </el-row>

                    <el-row v-if="item.approvalName != '修改点价订单'">
                      <el-col :span="12">审批人:{{ item.approver || "--" }}</el-col>
                      <el-col :span="12">审批时间：:{{ item.submitTime || "--" }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">提交人:{{ item.submitter || "--" }}</el-col>
                      <el-col :span="12">提交时间:{{ item.submitTime || "--" }}</el-col>
                    </el-row>
                    <el-row v-if="
                      item.fileList &&
                      item.fileList.length > 0 &&
                      item.approvalName != '修改点价订单'
                    ">
                      <el-col :span="24">
                        附件：
                        <div>
                          <file-upload readonly v-model="item.fileList"></file-upload>
                        </div>
                      </el-col>
                    </el-row>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" v-if="['1', '2'].includes(formData.orderStatus) && hasEdit"
                @click="onEdit">编辑</el-button>
              <el-button type="primary" v-if="!formData.parentOrderId && formData.orderStatus === '2' && formData.resState === '1' && formData.hgState === '1'"
                @click="onAddChild">{{ formData.orderType === '1' ? '品种规格转换' : '拆分点价数量' }}</el-button>
              <el-button type="primary" v-if="formData.orderStatus == 1 && hasApproval"
                @click="onAppoval">审批</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

    <!-- 审批 -->
    <ApprovalDialog urlType="2" :relatedId="orderId" v-if="showDlg" @closeDlg="showDlg = false" @successSave="loadData"
      :showDlg="showDlg"></ApprovalDialog>
    <OrderEditDlg :orderId="orderId" v-if="showEditDlg" @closeDlg="showEditDlg = false" @saveSuccess="loadData"
      :showDlg="showEditDlg"></OrderEditDlg>

  </div>
</template>

<script>
import ApprovalDialog from '@/views/zhyc/bondRecord/ApprovalDialog'
import OrderEditDlg from './OrderEditDlg'
import BigNumber from 'bignumber.js'
import { orderDepositType } from '@/utils/dict'

export default {
  name: 'orderManageDetail',
  components: { ApprovalDialog, OrderEditDlg },
  data() {
    return {
      orderDepositTypeMap: orderDepositType,
      formData: {
        orderId: '',
        orderNumber: '',
        priceOrderNo: '',
        latestPriceDate: '',
        futuresContract: '',
        basisPrice: '',
        lossBearer: '1',
        userId: '',
        specId: '',
        specName: '',
        lockedPrice: '',
        orderQuantity: '',
        usedQuantity: '',
        parentOrderId: '',
        priceDiff: '',
        lockedDeposit: '',
        orderStatus: '',
        isDel: '',
        createUserId: '',
        ctime: '',
        fileList: [],
        recordList: []
      },

      loading: false,
      showDetail: false,
      rowData: {},
      showDlg: false,
      showEditDlg: false
    }
  },
  created() {
    if (this.orderId) {
      this.loadData()
    }
    console.log('buttonList', this.buttonList)
  },
  computed: {
    orderId() {
      return this.$route.query.orderId
    },
    orderType() {
      return this.$route.query.orderType
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    }
  },
  methods: {
    onAddChild() {
      this.$router.push('/ycorderManage/add?orderType=' + this.formData.orderType + '&sourceType=2&orderId=' + this.formData.orderId + '&userId=' + this.formData.userId)
    },
    onEdit() {
      this.showEditDlg = true
    },
    onAppoval() {
      this.showDlg = true
    },
    onDetail(row) {
      this.rowData = row
      this.showDetail = true
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.yxcOrderManage.selectYxcPriceOrderByOrderId, {
          params: { orderId: this.orderId }
        })
        .then(res => {
          const orderQuantity = new BigNumber(res.orderQuantity || 0)
          const usedQuantity = new BigNumber(res.usedQuantity || 0)
          // 与提货选择页保持一致，进行中的提货也占用数量，超量后保留负数。
          const num = orderQuantity.minus(usedQuantity).minus(res.usedAddQuantity || 0)
          res.kyQuantity = Number(num.toFixed(3))

          res.fileList = res.fileList ? res.fileList : []
          res.recordList = res.recordList ? res.recordList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 100%;
}

.files {
  a {
    color: #1890ff;
  }
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
